export const DELETE_PATIENT_LIST = "DELETE_PATIENT_LIST"
export const DELETE_PATIENT_LIST_FAIL = "DELETE_PATIENT_LIST_FAIL"
export const DELETE_PATIENT_LIST_SUCCESS = "DELETE_PATIENT_LIST_SUCCESS"
export const DELETE_PATIENT_LIST_RESET = "DELETE_PATIENT_LIST_RESET"

export const deletePatientList = (params) => {
    return { type: DELETE_PATIENT_LIST, params }
}

export const deletePatientListSuccess = (response) => {
    return { type: DELETE_PATIENT_LIST_SUCCESS, response }
}

export const deletePatientListFail = (response) => {
    return { type: DELETE_PATIENT_LIST_FAIL, response }
}

export const deletePatientListReset = () => {
    return { type: DELETE_PATIENT_LIST_RESET }
}